export default __webpack_public_path__ + "static/media/html.bdc02079.svg";